import { Box, CircularProgress } from '@mui/material';
import { BrandLogo } from './BrandLogo';

/** Full-screen loader shown while the initial session-restore attempt runs. */
export function SplashScreen() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <BrandLogo height={48} />
        <CircularProgress size={28} thickness={4} />
      </Box>
    </Box>
  );
}
